import React from 'react'
import PropTypes from 'prop-types'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Card = ({ fields, cardBackground, uid }) => {
  var getintouch = ''
  if (uid === 'get-in-touch') {
    getintouch = '?wantedItem=' + fields.title.text.toString()
  }
  return (
    <div
      className={`component-card ease relative flex h-full flex-1 flex-grow transform flex-col overflow-hidden bg-white ${fields.button_link?.url != null && 'group transition duration-300 ease-in-out'}`}>
      {fields.image.gatsbyImageData && (
        <div className='relative z-10 overflow-hidden'>
          <GatsbyImage className='transition duration-300 ease-in-out group-hover:scale-105' image={fields.image.gatsbyImageData} alt={fields.image.alt || ''} />
        </div>
      )}
      <div className='m-6 flex flex-grow flex-col gap-6'>
        <div className={`prose ${cardBackground === true && 'prose-invert text-center'} prose-lg max-w-none`}>
          <PrismicRichText field={fields.title.richText} />
          <PrismicRichText field={fields.text.richText} />
        </div>
        <div className={`mt-auto text-center ${cardBackground === true && 'text-white'}`}>
          {fields.button_link.url && (
            <PrismicLink className='button button-info text-lg' href={`${fields.button_link.url}${getintouch}`}>
              {fields.button_text ? fields.button_text : 'Read more'}
              <span className='absolute inset-0 cursor-pointer' aria-hidden='true'></span>
            </PrismicLink>
          )}
        </div>
      </div>
    </div>
  )
}

Card.propTypes = {
  fields: PropTypes.object.isRequired
}

export default Card
